import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import { isRogers } from "../../../../../service/oneClickIs"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidBoard from "../../../../service/visibleValidator/isValidBoard"

import img from "./board.png"

const 材質 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { board: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="材質" helpURL={HELP_LINKS.材質} src={img}>
      <RadioGroup
        name={FIELD_NAMES.材質}
        selectedValue={values.board}
        onChange={handlers.radio}
        shouldRender={(value) => isValidBoard(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.材質["FR-4"].value}>FR-4</Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["高Tg材（Tg180 FR-4）"].value}>高Tg材（Tg180 FR-4）</Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["CEM-3"].value}>CEM-3</Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["ハロゲンフリー材（FR-4）(2層以下)"].value}>
            ハロゲンフリー材（FR-4）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["ハロゲンフリー材（FR-4）(4層)"].value}>ハロゲンフリー材（FR-4）</Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["ハロゲンフリー材（FR-4）(6層)"].value}>ハロゲンフリー材（FR-4）</Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["ハロゲンフリー材（FR-4）(8層以上)"].value}>
            ハロゲンフリー材（FR-4）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["FR-1"].value}>FR-1</Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["パナソニック材（R1705相当品FR-4）"].value}>
            パナソニック材（R1705相当品FR-4）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["耐トラッキング材（CTI600 FR-4）"].value}>
            耐トラッキング材（CTI600 FR-4）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["Rogers材（4350B）"].value}>Rogers材（4350B）</Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["パナソニック材（MEGTRON6）"].value}>パナソニック材（MEGTRON6）</Radio>

          <Radio value={ESTIMATE_CONSTANT.材質["銅箔＋接着層＋PI（ポリイミド）"].value}>
            銅箔＋接着層＋PI（ポリイミド）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.材質["銅箔＋PI（ポリイミド）"].value}>銅箔＋PI（ポリイミド）</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.board}>
        {/* TODO サーバーからエラーを出力するようにして削除する  */}
        {isRogers(values) && (
          <>
            <p>※銅箔厚みは「18μm」か、「35μm」のお受付となります。</p>
            <p>
              ※表面処理は「水溶性フラックス」、「無電解金フラッシュ」、「リード無し電解金めっき」、「しない（銅箔のみ）」のお受付となります。
            </p>
          </>
        )}
      </OneClickFieldMessages>
    </OneClickField>
  )
}

export default 材質
